// extracted by mini-css-extract-plugin
module.exports = {"center":"Table_center__1Wb-Y"};